// extracted by mini-css-extract-plugin
export var centeredContent = "styles-module--centeredContent--2Z15Z";
export var container = "styles-module--container--aOmFI";
export var filled = "styles-module--filled--EchZW";
export var fullWidth = "styles-module--fullWidth--4kT9_";
export var icon = "styles-module--icon--dysai";
export var outline = "styles-module--outline--25O61";